import React from 'react';
import { FaPaperPlane, FaEnvelope } from 'react-icons/fa';

const ContactPageComponent = () => {
  return (
    <div className=" bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white  rounded-lg p-8">
        <h2 className="text-3xl font-bold flex items-center text-left text-blue-900 mb-6">
          <FaEnvelope className="text-green-600 text-2xl mr-3" />          
          Contact Us
        </h2>
        <hr className='mb-4'/>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <form className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Full Name:</label>
              <input
                type="text"
                style={{ border: "1px solid lightblue" }}
                className="mt-1 p-4 block w-full border-gray-700 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your full name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Email:</label>
              <input
                type="email"
                style={{ border: "1px solid lightblue" }}
                className="mt-1 p-4  block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="you@example.com"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Phone Number:</label>
              <input
                type="tel"
                style={{ border: "1px solid lightblue" }}
                className="mt-1 p-4  block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your phone number"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Message:</label>
              <textarea
                rows={6}
                style={{ border: "1px solid lightblue" }}
                className="mt-1 p-4  block w-full rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Type your message here..."
              />
            </div>

          <button className="flex items-center gap-2 px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 w-full justify-center transition">
            <FaPaperPlane className="text-lg" />
            Send Message
          </button>

          </form>

          <div className="flex flex-col justify-center space-y-4">
            <div>
                <img style={{margin: "0 auto"}} src='/logo512.png' alt='ipsa_logo'/>
            </div>
            <p className="text-lg text-gray-700">
              <strong>Institute for Patient Safety Africa (IPSA)</strong>
            </p>
            <p className="text-gray-600">
              Supporting hospitals, clinics, and healthcare organizations across Kenya.
            </p>
            <p className="text-gray-600">
              📍 Nairobi, Kenya
            </p>
            <p className="text-gray-600">
              📧 info@ipsa-africa.org
            </p>
            <p className="text-gray-600">
              📞 +254 712 345 678
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPageComponent;
